import { createEnum } from '@cloud-wave/neon-common-lib/common';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import Icon from '../Icon';
import Text from '../Text';

import './badge.scss';

export const BadgeTypes = createEnum('NEUTRAL', 'SUCCESS', 'WARNING', 'HOLD', 'DANGER', 'DEFAULT', 'WHITE');
export type TBadgeType = keyof typeof BadgeTypes;

export type BadgeProps = {
  label?: string;
  icon?: IconDefinition;
  type?: TBadgeType;
  variant?: 'solid' | 'glass';
  reverse?: boolean;
  bold?: boolean;
  className?: string;
  minWidth?: number;
  isTimer?: boolean;
  ariaLabel?: string;
};

export default function Badge({
  type = 'SUCCESS',
  variant = 'solid',
  reverse,
  icon,
  label,
  className,
  bold,
  minWidth,
  isTimer,
  ariaLabel
}: BadgeProps) {
  const labelEl = (
    <Text bold={bold} type="extraSmall" className={'badge__content'}>
      {label}
    </Text>
  );

  return (
    <div
      role={isTimer ? 'timer' : void 0}
      tabIndex={isTimer ? 0 : void 0}
      className={cx('badge', `badge__${type.toLowerCase()}`, className, {
        'badge--reverse': reverse,
        'badge--glass': variant === 'glass',
        [`badge--glass-${type.toLowerCase()}`]: variant === 'glass'
      })}
      style={{ minWidth }}
    >
      {ariaLabel && (
        <span className="sr-only">
          {ariaLabel} {label}
        </span>
      )}
      {icon && <Icon icon={icon} size={15} className={'badge__content'} />}
      {label && labelEl}
    </div>
  );
}
